<template>
  <div v-if="rewards.items !== null" class="o-rewards__cardgroup">
    <section
      v-for = "reward in rewards.items"
      class = "c-card c-card--reward qa-card"
    >
      <router-link
        :to   = "getRouterLink(reward)"
        class = "c-card--reward__link"
      >
        <div class="c-card--reward__thumbnail">
          <img
            v-if  = "getImgUrl(reward)"
            :src  = "getImgUrl(reward)"
            class = "c-card--reward__thumbnail__img"
          />

          <img
            v-else
            src   = "/img/thm350.png"
            class = "c-card--reward__thumbnail__placeholder"
          />
        </div>

        <div class="c-card--reward__info">
          <h2 class="c-card--reward__info__name t-link">
            {{ reward.name }}
          </h2>

          <div class="c-card--reward__info__cost" v-if="reward.supplier_items">
            <i class="fa fa-star t-points-icon"></i>
            <span v-if="rewardHasRange(reward)">From</span>
            <vue-numeric
              separator  = ","
              :read-only = "true"
              :value    = "getRewardPrice(reward)">
            </vue-numeric>
          </div>
        </div>
      </router-link>
    </section>


    <section
      v-if  = "rewards.items !== null && Object.keys(rewards.items).length === 0"
      class = "c-no-results qa-no-results"
    >
      <p class="c-no-results__p t-headline">{{ $t('web.catalog_rewards_list.no_rewards') }}</p>
    </section>
  </div>
</template>




<script>

import VueNumeric from 'vue-numeric'
import { mapGetters } from 'vuex'

export default {
  name: 'RewardsList',
  components: {
    'vue-numeric': VueNumeric
  },
  computed: {
    ...mapGetters([
      'rewards',
      'participant'
    ]),
    currencyCode: function () {
      return this.participant.points_currency_code || 0
    }
  },
  methods: {
    getImgUrl (reward) {
      if (reward.images) {
        return reward.images[0].sizes['350x350']
      } else if (reward.image) {
        return reward.image.url
      }

      return ''
    },
    getRouterLink (reward) {
      if (reward.hasOwnProperty('id')) {
        return {name: 'Single Reward', params: {id: reward.id}}
      }

      return {name: 'Rewards Results', query: {category: reward.code}}
    },
    getRewardPrice (reward) {
      if (this.rewardHasRange(reward)) {
        return reward.supplier_items[0].prices.sale_price_range.min
      }

      return reward.supplier_items[0].prices.sale_price[this.currencyCode]
    },
    rewardHasRange (reward) {
      return reward.supplier_items[0].prices.sale_price[this.currencyCode] === 0 &&
        reward.supplier_items[0].prices.sale_price_range &&
        reward.supplier_items[0].prices.sale_price_range.min
    }
  }
}
</script>



// WEBPACK FOOTER //
// RewardsList.vue?2afb162c